import { ISuggestResponseSchema } from '../repositories/newbuilding-promos/entities/suggest/SuggestResponseSchema';
import { ESuggestionType, ISuggestionItem } from '../types/suggestions';

export const prepareSuggestions = (response: ISuggestResponseSchema): ISuggestionItem[] => {
  const suggestions = response.suggestions;

  return suggestions.map(suggestion => {
    return {
      ...suggestion,
      type: suggestion.type as unknown as ESuggestionType,
    };
  });
};
